import i18next, { Resource } from 'i18next';

const objectDepth = (o: object): number =>
  Object(o) === o ? 1 + Math.max(-1, ...Object.values(o).map(objectDepth)) : 0;

/**
 * Adds the given resources to i18next.
 * If the resource file contains only top-level translations, they are added under the given namespace, per language:
 *   { "title": "Title", "body": "Body", ... }
 * If the resource file has nested translations, the namespace param is prepended onto each top level key
 * to create the namespace for its nested translations. Mutliple layers of nesting is not supported.
 *   {
 *     Component1: {
 *       "title": "Title", ...
 *     },
 *     Componet2: ...
 *   }
 * @param namespace optionally adds top level translations under this namespace.
 */
function addResources(resources: Resource, namespace: string): void {
  if (objectDepth(resources) > 2) {
    Object.keys(resources).forEach((lng) =>
      Object.keys(resources[lng]).forEach((ns) =>
        i18next.addResourceBundle(
          lng,
          `${namespace}.${ns}`,
          resources[lng][ns],
        ),
      ),
    );
  } else {
    Object.keys(resources).forEach((lng) =>
      i18next.addResourceBundle(lng, namespace, resources[lng]),
    );
  }
}

export default addResources;
